module.exports = __webpack_public_path__ + "static/img/yue.17e9d196.png";